import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import SWOTSingapore from './SWOTSingapore';

function App() {
  return (
    <SWOTSingapore></SWOTSingapore>
  );
}

export default App;